import React from "react";
import PropTypes from "prop-types";
import styles from "components/dashboard/dashboard.scss";
import { ItemBox } from "components/common/item-box";

export const UsageDashboard = (props) => (
  <div>
    <h1>Hey there { props.name }!</h1>
    <div className={ styles["usage-container"] }>
      <h2>This Months Usage:</h2>
      <div>
        <ItemBox
          denominator={ false }
          info={ "Documents processing" }
          number={ props.pendingDocumentCount }
        />
        <ItemBox
          denominator={ props.documentLimit }
          info={ "Documents" }
          number={ props.documentCount }
        />
        <ItemBox
          denominator={ props.envelopeLimit }
          info={ "Envelopes" }
          number={ props.envelopeCount }
        />
      </div>
      <div className={ styles.ruler } />
      <h2>Totals:</h2>
      <div>
        <ItemBox
          denominator={ false }
          info={ "Total Documents" }
          number={ props.totalCount }
        />
        <ItemBox
          denominator={ false }
          info={ "Total Document Value" }
          number={ `$${props.totalSumFiltered}` }
        />
        <ItemBox
          denominator={ false }
          info={ "Number of Vendors" }
          number={ props.vendorsCount }
        />
      </div>
    </div>
  </div>
);

UsageDashboard.propTypes = {
  documentCount: PropTypes.number.isRequired,
  documentLimit: PropTypes.number.isRequired,
  envelopeCount: PropTypes.number.isRequired,
  envelopeLimit: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  pendingDocumentCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  totalSumFiltered: PropTypes.string.isRequired,
  vendorsCount: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/dashboard/usage-dashboard.jsx